// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"FormLabel_componentStyle__gOJBO","requiredMark":"FormLabel_requiredMark__Buhw9"};